export default "__VITE_ASSET__CvQgfmwt__"